import {
  SubNavigationBar,
  SubNavigationItem,
} from '@/modules/shared/components'
import * as React from 'react'
import { VEHICLE_ROUTES } from '../routes-typed'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const Navigation = ({
  companyId,
  selectedVehicleId,
}: {
  companyId: string | number
  selectedVehicleId?: string | number | null
}) => {
  const { t } = useLocalize()
  const cid = companyId
  const vid = selectedVehicleId != null ? Number(selectedVehicleId) : null

  return (
    <SubNavigationBar>
      <SubNavigationItem to={VEHICLE_ROUTES.list.buildPath({ companyId: cid })}>
        {t('tab.basic-data')}
      </SubNavigationItem>
      {/*
        Activities only makes sense for a concrete vehicle. If none is
        selected, render the tab as disabled rather than producing an URL
        the calendar page can't resolve (the old code used a `vehicleId='all'`
        sentinel, but nothing downstream handled it).
      */}
      <SubNavigationItem
        to={
          vid != null
            ? VEHICLE_ROUTES.calendar.buildPath({
                companyId: cid,
                vehicleId: vid,
                year: new Date().getFullYear(),
              })
            : ''
        }
        disabled={vid == null}
      >
        {t('tab.activities')}
      </SubNavigationItem>
      <SubNavigationItem
        to={VEHICLE_ROUTES.blocksList.buildPath({ companyId: cid })}
      >
        {t('tab.blocks')}
      </SubNavigationItem>
    </SubNavigationBar>
  )
}

export default Navigation
